module.exports = __webpack_public_path__ + "img/calendar-3.5e7b7c61.svg";